"use strict";

window._theme = window._theme || {};

class ViewTrack {
  constructor() {
    window.dataLayer = window.dataLayer || [];
    this.isMobile = window.innerWidth < 1025 ? true : false;
  }

  init = () => {
    this.buildSelectors();
    this.initViewTrackEvents();
    this.initClickTrackEvent();
    // this.initHoverTrackEvent();
    this.init404PageTrackEvent();
  }

  initOnLoad = () => {
    const listrakModalBtn = document.getElementById("ltkPopupTriggerButton");
    if (listrakModalBtn) this.trackView("Listrak newsletter model");
  }

  buildSelectors = () => {
    this.selectors = {};
    
    this.selectors.trackElements = [
      {
        elem: document.querySelector("#shopify-section-header-new .header-top"),
        msg: "Announcement-bar",
        trackView: true,
        trackClick: false,
        trackMouseHover: false
      },
      {
        elems: Array.from(document.querySelectorAll(".shopify-section.image-with-text-card-container-2-section .image-with-text-card-item-link")),
        msg: "Hero banner",
        trackView: true,
        trackClick: true,
        trackMouseHover: false
      },
      {
        elem: document.querySelector(".shopify-section.home-brands-sections"),
        msg: "Brands slider",
        trackView: true,
        trackClick: false,
        trackMouseHover: false
      },
      // {
      //   elems: Array.from(document.querySelectorAll('.shopify-section.home-feature-product-sections [data-featured-products] .image-with-text-card-item-link')),
      //   msg: null,
      //   defaultMsg: "Banner View",
      //   trackView: true,
      //   trackClick: false,
      //   trackMouseHover: false,
      //   async: true
      // },
      {
        elems: Array.from(document.querySelectorAll('.shopify-section .image-with-text-card-main-container-1 .image-with-text-card-item')),
        msg: "Home collection",
        trackView: true,
        trackClick: false,
        trackMouseHover: false
      },
      {
        elems: Array.from(document.querySelectorAll('.shopify-section .image-with-text-card-main-container .image-card-item-link')),
        msg: "Home collection card",
        trackView: true,
        trackClick: false,
        trackMouseHover: false
      },
      {
        elems: Array.from(document.querySelectorAll(".template-collection .product-collection .banner-item-coll")).filter(node => node.clientHeight !== 0),
        msg: "Collection product grid banner",
        trackView: true,
        trackClick: false,
        trackMouseHover: false
      },
      {
        elems: Array.from(document.querySelectorAll(".product-shop .productAnchorPromo")).filter(node => node.clientHeight !== 0),
        msg: null,
        defaultMsg: "PDP Offer Label",
        trackView: true,
        trackClick: false,
        trackMouseHover: false
      },
      // {
      //   elems: Array.from(document.querySelectorAll('.inner.product-item .quickview-button')),
      //   msg: "Quickview",
      //   trackView: false,
      //   trackClick: false,
      //   trackMouseHover: true
      // }
    ];
  }

  initViewTrackEvents = () => {
    const callbackFn = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {          
          try {
            const target = entry.target;
            const item = this.getTargetConfig(target);
            let eventText = (item.targetIndex && item.elems && item.elems.length > 1) !== 0 ?  `${item.msg} ${item.targetIndex}` : item.msg;
            if(!item.msg) eventText = target.textContent?.trim() || target.getAttribute('aria-label') || item.defaultMsg;
            this.trackView(eventText);
            observer.unobserve(target);
          } catch (error) {
            observer.unobserve(target);
          }
        }
      });
    };

    const observerIns = new IntersectionObserver(callbackFn, {
      root: null,
      rootMargin: "0px 0px 0px 0px",
      threshold: 0.80,
    });

    this.selectors.trackElements.forEach((item) => {
      if(!item.trackView) return;

      if (item.elem) observerIns.observe(item.elem);
      if (item.elems) {
        item.elems.forEach(itemElem => {
          observerIns.observe(itemElem);
        });
      }
    });
  }

  initClickTrackEvent = () => {
    this.selectors.trackElements.forEach((item) => {
      if(!item.trackClick) return;
      
      if (item.elem) {
        item.elem.addEventListener('click', this.handleTrackClick);
      }

      if (item.elems) {
        item.elems.forEach(itemElem => {
          itemElem.addEventListener('click', this.handleTrackClick);
        });
      }
    });
  }

  initHoverTrackEvent = () => {
    if(this.isMobile) return;

    this.selectors.trackElements.forEach(item => {
      if(!item.trackMouseHover || !item.elems || item.elems.length === 0) return;

      let timer;
      item.elems.forEach(elem => {
        elem.addEventListener('mouseenter', evt => {
          timer = setTimeout(() => {
            this.trackView(item.msg);
          }, 300);
        });

        elem.addEventListener('mouseleave', evt => {
          clearTimeout(timer);
        });
      });
    });
  }

  init404PageTrackEvent = () => {
    const body = document.body;
    if (!body || body.getAttribute("data-template") !== "404") return;

    setTimeout(() => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: '404_page',
        pageUrl: window.location.href,
        pageReferrer: document.referrer || 'Direct'
      });
    }, 300);
  };

  handleTrackClick = (evt) => {
    evt.preventDefault();
    
    let eventText = "Banner Click";
    const target = evt.target;
    const targetItem = this.getTargetConfig(target);
    if(targetItem) {
      eventText = targetItem.msg;
      if(targetItem.targetIndex !== 0) eventText += ' ' + targetItem.targetIndex;
    }
    this.trackClick(eventText);

    const linkTag = target.nodeName === "A" ? target : target.closest('a');
    if(linkTag){
      setTimeout(() => {
        window.location.href = linkTag.href;
      }, 250);
    }
  }

  /**
   * @param {string} title 
   * @param {number} index 
   * @returns void
   */
  trackView = (title, index) => {
    if (!title) return;

    try {
      window.dataLayer.push({
        event: "banner_view",
        banner_name: title,
        banner_index: index || 0,
      });
    } catch (error) {
      console.warn('Error while tracking view');
    }
  }

  /**
   * @param {string} title 
   * @param {number} index 
   * @returns void
   */
  trackClick = (title, index) => {
    if (!title) return;

    try {
      window.dataLayer.push({
        event: "banner_click",
        bannername_: title,
        bannerindex: index || 0,
      });
    } catch (error) {
      console.warn('Error while tracking click');
    }
  }

  /**
   * @param {{productTitle: string, variantTitle: string, variantPrice: number}} data 
   * @returns void
   */
  trackQuickView = (data) => {
    if(!data.productTitle || !data.variantTitle || !data.variantPrice) return;

    window.dataLayer.push({
      event: "Quickview ATC",
      product_name: data.productTitle,
      product_variant: data.variantTitle,
      product_price: data.variantPrice
    });
  }

  /**
   * 
   * @param {string} event 
   * @param {string} method 
   */
  trackEvent = (event, method) => {
    if(!event || !method) return;

    window.dataLayer.push({
      event: event,
      method: method
    });
  }

  /**
   * 
   * @param {{}} data 
   * @returns void
   */
  trackData = (data = {}) => {
    if(!data || typeof data !== "object") return;

    window.dataLayer.push({
      ...data
    });
  }

  getTargetConfig(target){
    if(!target) return null;
    
    let targetIndex = 0;
    const item = this.selectors.trackElements.find((item) => {
      if(item.elem) return item.elem === target;

      if(item.elems) return item.elems.find((elem, index) => {
        if(elem === target){
          targetIndex = index + 1;
          return true;
        }

        return false;
      });
    });

    if(item) item['targetIndex'] = targetIndex;

    return item;
  }
}

_theme.track = new ViewTrack();

document.addEventListener("DOMContentLoaded", function (event) {
    _theme.track.init();
});

window.onload = function () {
  _theme.track.initOnLoad();
};